import { useAppSelector } from '@redux/hooks';

export const useGetAbsoluteUrl = (href: string): string => {
  const host = useAppSelector(state => state.header.data.host);

  return host + href;
};
